import 'babel-polyfill';
// import 'es6-promise/auto';

if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = function (callback, argument) {
		argument = argument || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(argument, this[i], i, this);
		}
	};
}

if (!Element.prototype.matches) {
	Element.prototype.matches =
		Element.prototype.matchesSelector ||
		Element.prototype.mozMatchesSelector ||
		Element.prototype.msMatchesSelector ||
		Element.prototype.oMatchesSelector ||
		Element.prototype.webkitMatchesSelector;
}




// WEBPACK FOOTER //
// ./src/utils/polyfills.js